"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withType = exports.param = exports.header = void 0;
const prelude_1 = require("@packages/prelude");
/**
 * pipe(http.get(url), http.header('x-header', 'value'))
 */
const header = (name, value) => (req) => ({
    ...req,
    headers: (0, prelude_1.pipe)(req.headers, prelude_1.RR.upsertAt(name, value))
});
exports.header = header;
/**
 * pipe(http.get(url), http.header('page', '1'))
 */
const param = (name, value) => (req) => ({
    ...req,
    params: (0, prelude_1.pipe)(req.params, prelude_1.RR.upsertAt(name, value))
});
exports.param = param;
/**
 * pipe(http.get(url), http.withType(MyType))
 */
const withType = (decoder) => (req) => ({
    ...(0, exports.header)('Content-Type', 'application/json')(req),
    decoder: prelude_1.t.JsonFromString.pipe(decoder)
});
exports.withType = withType;
//# sourceMappingURL=Request.js.map